// Recovered compiled webpack factory 90737. Edit this function expression; run npm run build.
(e, t, r) => {
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "AmpStateContext", {
      enumerable: !0,
      get: function () {
        return n;
      },
    }));
  let n = r(28140)._(r(12115)).default.createContext({});
}
